import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { isChrome, isChromium, isEdge } from 'react-device-detect';
import { createPortal } from 'react-dom';

interface NavbarPortalProps {
  children?: ReactNode;
  fullWidth?: boolean;
}

const navbarElement: HTMLElement | null = document.getElementById('navbar-root');

const NavbarPortal = ({ children, fullWidth = false }: NavbarPortalProps) => {
  const { t } = useTranslation('navbar');

  if (!navbarElement) {
    return null;
  }

  return createPortal(
    isChrome || isChromium || isEdge ? (
      <div className={`header-navbar grid--container ${fullWidth ? '' : 'columns'}`}>
        <div className={`navbar--container ${fullWidth ? '' : 'navbar--content-columns'}`}>{children}</div>
      </div>
    ) : (
      <div className="navbar--wrapper">
        <div className={`header-navbar grid--container ${fullWidth ? '' : 'columns'}`}>
          <div className={`navbar--container ${fullWidth ? '' : 'navbar--content-columns'}`}>{children}</div>
        </div>
        <div className="navbar--unsupported-browser">
          <h3 className="m-2">
            {t('unsupported-browser')}{' '}
            <a target="_blank" rel="noreferrer" href="https://www.google.com/chrome/" style={{ textDecoration: 'underline', fontWeight: 900 }}>
              {t('unsupported-browser.here')}
            </a>{' '}
            {t('unsupported-browser.or-edge')}{' '}
            <a target="_blank" rel="noreferrer" href="https://www.microsoft.com/en-us/edge/download" style={{ textDecoration: 'underline', fontWeight: 900 }}>
              {t('unsupported-browser.here')}.
            </a>
          </h3>
        </div>
      </div>
    ),
    navbarElement
  );
};

export default NavbarPortal;
